import api from '@/api'

export const connectSync = {
  namespaced: true,
  state: {
    documentUploads: [],
    documentTypes: [],
    statusSyncs: []
  },
  getters: {
    documentUploads: state => state.documentUploads,
    documentTypes: state => state.documentTypes,
    statusSyncs: state => state.statusSyncs
  },
  mutations: {
    SET_DOCUMENT_UPLOADS(state, data) {
      state.documentUploads = data || []
    },
    SET_DOCUMENT_TYPES(state, data) {
      state.documentTypes = data || []
    },
    SET_STATUS_SYNCS(state, data) {
      state.statusSyncs = data || []
    }
  },
  actions: {
    async getDocumentUploads({ commit }, workOrderId) {
      const response = await api.getDocumentUploads(workOrderId)
      commit('SET_DOCUMENT_UPLOADS', response.data)
    },
    async getDocumentTypes({ commit }) {
      const response = await api.getConnectDocumentTypes()
      commit('SET_DOCUMENT_TYPES', response.data)
    },
    resendDocumentUpload(context, id) {
      return api.resendDocumentUpload(id)
    },
    getDocumentPreview(context, { workOrderId, documentTypeId }) {
      return api.getDocumentPreview(workOrderId, documentTypeId)
    },
    async getStatusSyncs({ commit }, workOrderId) {
      const response = await api.getStatusSyncs(workOrderId)
      commit('SET_STATUS_SYNCS', response.data)
    },
    resendStatusSync(context, id) {
      return api.resendStatusSync(id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/connectsync/index.js